export default function Contents() {
  return (
    <section id="contents" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block px-5 py-2 bg-teal-50 border border-teal-200 rounded-full mb-4">
            <span className="text-teal-600 text-xs md:text-sm font-bold uppercase tracking-wider">Product Components</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-900 mb-4 md:mb-6">
            Product <span className="text-teal-600">Components</span>
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-3xl mx-auto font-medium leading-relaxed">
            Discover our products that combine innovative technology with practical design
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="h-64 md:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/7ee426d1a4a86fadeda045b679aea333.jpg"
                alt="Power Generation Meter"
                title="ROBO Asset Grid Power Generation Meter"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 md:mb-4">
                Power Generation Meter
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed font-medium">
                A smart meter that measures and monitors power generation in real-time. 
                Supports efficient energy management through accurate data collection and analysis.
              </p>
              <ul className="space-y-2 md:space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Real-time power generation measurement and display</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Cumulative power generation data storage</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">High-precision sensor technology applied</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Easy installation and maintenance</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-lg overflow-hidden border border-gray-100">
            <div className="h-64 md:h-96">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20white%20smart%20home%20energy%20monitoring%20display%20panel%20with%20touchscreen%20interface%2C%20showing%20real%20time%20power%20consumption%20graphs%20and%20data%2C%20wall%20mounted%2C%20sleek%20minimalist%20design%2C%20LED%20screen%2C%20professional%20product%20photography%2C%20soft%20lighting%2C%20high%20tech%20appearance%2C%20simple%20background%2C%20studio%20shot%2C%20modern%20home%20interior%2C%20energy%20management%20system%2C%20clean%20aesthetic%2C%20front%20view&width=600&height=400&seq=contents-display-1&orientation=landscape"
                alt="Display Device"
                title="ROBO Asset Grid Display Device"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-black text-gray-900 mb-3 md:mb-4">
                Display Device
              </h3>
              <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6 leading-relaxed font-medium">
                A display device that allows you to check power generation status at a glance with an intuitive interface. 
                User-friendly design makes it easy for anyone to check information.
              </p>
              <ul className="space-y-2 md:space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">High-resolution display</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Intuitive user interface</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Various data visualization</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-teal-500 text-lg md:text-xl mr-2 md:mr-3 mt-0.5"></i>
                  <span className="text-sm md:text-base text-gray-700 font-medium">Remote monitoring support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}